import NumberFormat, { NumberFormatProps } from "react-number-format";
import { FC } from "react";

interface IVuiNumberFormat {}

const VuiNumberFormat: FC<IVuiNumberFormat & NumberFormatProps> = (props) => {
  const {
    thousandSeparator = ".",
    decimalSeparator = ",",
    displayType = "text",
    prefix = "Rp ",
    decimalScale = 0,
    ...other
  } = props;

  return (
    <NumberFormat
      {...other}
      displayType={displayType}
      thousandSeparator={thousandSeparator}
      prefix={prefix}
      decimalScale={decimalScale}
      decimalSeparator={decimalSeparator}
    />
  );
};

export default VuiNumberFormat;
